// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"548":"3d33a12e","1165":"4ce2ec42","5018":"921e2bf7","5825":"0a517bd5","6977":"31b1a643","9781":"6ba51ca0"}[chunkId] + ".chunk.css";
};